import { render, staticRenderFns } from "./portraitRecords.vue?vue&type=template&id=d028fe42&scoped=true"
import script from "./portraitRecords.vue?vue&type=script&lang=js"
export * from "./portraitRecords.vue?vue&type=script&lang=js"
import style0 from "./portraitRecords.vue?vue&type=style&index=0&id=d028fe42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d028fe42",
  null
  
)

export default component.exports